import { ArrowUpRight } from "lucide-react";
import { Reveal, ChapterHeading } from "./Reveal";
import PayButtons from "./PayButtons";
import { WORKSHOPS, waLink } from "@/config";

const Workshops = () => (
  <section id="etkinlikler" data-testid="workshops-section" className="relative z-10 py-24 sm:py-32">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <ChapterHeading
        chapter={WORKSHOPS.chapter}
        label={WORKSHOPS.label}
        title={WORKSHOPS.title}
        subtext={WORKSHOPS.subtext}
        align="center"
      />

      <div className="mt-16">
        {WORKSHOPS.items.map((w, i) => (
          <Reveal key={w.id} delay={i * 0.12}>
            <div
              data-testid={w.testId}
              className="group grid md:grid-cols-[130px_1fr_auto] gap-6 md:gap-10 items-center border-t border-gold/20 py-9 md:py-11 transition-colors duration-500 hover:bg-navy-800/40 px-2 sm:px-4"
            >
              <div className="flex md:flex-col items-baseline md:items-start gap-2">
                <span className="font-serif text-5xl md:text-6xl text-gold leading-none">{w.day}</span>
                <span className="font-mono text-xs tracking-[0.2em] text-mist uppercase">
                  {w.month}
                </span>
                <span className="font-mono text-[11px] text-cream/50">{w.time}</span>
              </div>

              <div>
                <h3 className="font-serif text-2xl sm:text-3xl text-cream">{w.name}</h3>
                <p className="mt-3 max-w-xl text-sm text-mist leading-relaxed">{w.description}</p>
                <span className="mt-4 inline-block rounded-full border border-gold/30 bg-gold/10 px-4 py-1 text-[11px] font-mono uppercase tracking-widest text-gold">
                  {w.spots}
                </span>
              </div>

              <div className="flex md:flex-col items-center md:items-end gap-4">
                <span className="font-serif text-3xl text-gold" data-testid={`${w.testId}-price`}>
                  {w.price}
                </span>
                <div className="flex flex-wrap md:justify-end gap-3">
                  <PayButtons productId={w.id} title={w.name} testId={w.testId} variant="inline" />
                  <a
                    href={waLink(w.waMessage)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`${w.testId}-cta`}
                    className="inline-flex items-center gap-2 rounded-full border border-gold/50 px-6 py-3 text-sm font-semibold text-cream transition-all duration-300 hover:bg-gold hover:text-ink hover:border-gold"
                  >
                    Kayıt Ol
                    <ArrowUpRight className="w-4 h-4" />
                  </a>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
        <div className="border-t border-gold/20" />
      </div>
    </div>
  </section>
);

export default Workshops;
